import { render } from "./PanelSuscripcionUsuario.vue?vue&type=template&id=4238df87&scoped=true"
import script from "./PanelSuscripcionUsuario.vue?vue&type=script&lang=js"
export * from "./PanelSuscripcionUsuario.vue?vue&type=script&lang=js"

import "./PanelSuscripcionUsuario.vue?vue&type=style&index=0&id=4238df87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4238df87"]])

export default __exports__